import { useState } from 'react'

import { eLockInfo, Links } from 'sections/PromoSection/modules/ELockModule/components/Description/types'
import { BlockWrap } from 'components/AdminV2/BlockWrap/BlockWrap'
import { AdminElemVisibilityToggle } from 'components/AdminV2/UI/ElemVisibilityToggle/AdminElemVisibilityToggle'
import { AdminHeaderBlockElem } from 'components/AdminV2/UI/HeaderBlockElem/AdminHeaderBlockElem'
import { AdminInput } from 'components/AdminV2/UI/Input/AdminInput'
import { SectionName } from 'types/types'

type ElockBlockIItemProps = {
  lock: eLockInfo
  onChange: (index: number, key: Exclude<keyof eLockInfo, 'links'>, value: string) => void
  onLinkChange: (index: number, key: keyof Links, value: string) => void
  onDelete: (index: number) => void
}

export const ElockBlockItem = ({ lock, onChange, onLinkChange, onDelete }: ElockBlockIItemProps) => {
  const [isExpanded, setExpanded] = useState(false)

  return (
    <BlockWrap key={lock.index} type={SectionName.elock} text={lock.model}>
      <>
        <AdminHeaderBlockElem index={lock.index} text={lock.model} onClick={() => onDelete(lock.index)} />

        <AdminElemVisibilityToggle
          text="Параметры модели"
          isVisible={isExpanded}
          setVisible={() => setExpanded((prev) => !prev)}
        />

        {isExpanded && (
          <>
            <AdminInput
              label="Модель замка"
              value={lock.model}
              onChange={(value) => onChange(lock.index, 'model', value)}
            />
            <AdminInput label="Вид замка" value={lock.type} onChange={(value) => onChange(lock.index, 'type', value)} />
            <AdminInput
              label="Тип замка"
              value={lock.lockType}
              onChange={(value) => onChange(lock.index, 'lockType', value)}
            />
            <AdminInput
              label="Для каких дверей"
              value={lock.forDoors}
              onChange={(value) => onChange(lock.index, 'forDoors', value)}
            />
            <AdminInput
              label="Напряжение"
              value={lock.voltage}
              onChange={(value) => onChange(lock.index, 'voltage', value)}
            />
            <AdminInput label="Ток" value={lock.current} onChange={(value) => onChange(lock.index, 'current', value)} />
            <AdminInput
              label="Открывается ключом"
              value={lock.keyOpen}
              onChange={(value) => onChange(lock.index, 'keyOpen', value)}
            />
            <AdminInput
              label="Может работать в режиме «постоянно открыто»"
              value={lock.alwaysOpen}
              onChange={(value) => onChange(lock.index, 'alwaysOpen', value)}
            />
            <AdminInput
              label="Инструкция"
              value={lock.links.instruction || ''}
              onChange={(value) => onLinkChange(lock.index, 'instruction', value)}
            />
            <AdminInput
              label="Сайт производителя"
              value={lock.links.webSite || ''}
              onChange={(value) => onLinkChange(lock.index, 'webSite', value)}
            />
            <AdminInput
              label="Руководство"
              value={lock.links.manual || ''}
              onChange={(value) => onLinkChange(lock.index, 'manual', value)}
            />
            <AdminInput
              label="Паспорт на замок"
              value={lock.links.elockPassport || ''}
              onChange={(value) => onLinkChange(lock.index, 'elockPassport', value)}
            />
            <AdminInput
              label="Схема подключения"
              value={lock.links.installationScheme || ''}
              onChange={(value) => onLinkChange(lock.index, 'installationScheme', value)}
            />
          </>
        )}
      </>
    </BlockWrap>
  )
}
